
export class AppointmentConfirmationInput {    
    ldc: string = '';

    selectedTimeSlot: string = '';
    selectedTimeSlotWindow: string = '';
    entranceInstructionsList: string[] = [];
    specialFeeMsg: string = '';
    logReferenceID: string = '';
    portalTypeID: number = 0;
    emailToList: string = '';
}
export class AppointmentConfirmationOutput {
   
}
